/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { RootV2, RootV2Interface } from "../RootV2";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "CreateProject",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "token",
            type: "address",
          },
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "claimToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "claimDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "claimPercent",
            type: "uint256[]",
          },
        ],
        indexed: false,
        internalType: "struct RootV2.ProjectProps",
        name: "newProps",
        type: "tuple",
      },
    ],
    name: "ProjectPropsChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "investor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum VoucherV2.RedeemType",
        name: "redeemType",
        type: "uint8",
      },
    ],
    name: "RedeemIdo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "investor",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum VoucherV2.RedeemType",
        name: "redeemType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "boxIDs",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "boxCounts",
        type: "uint256[]",
      },
    ],
    name: "RedeemIno",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "investor",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "enum VoucherV2.RefundType",
        name: "refundType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "enum VoucherV2.OfferingType",
        name: "offeringType",
        type: "uint8",
      },
    ],
    name: "Refund",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "voucherSigner",
        type: "address",
      },
    ],
    name: "__RootV1_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
    ],
    name: "addAdmins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "users",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "enum VoucherV2.RedeemType[]",
        name: "redeemTypes",
        type: "uint8[]",
      },
    ],
    name: "addIdoBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "investors",
        type: "address[]",
      },
    ],
    name: "airDrop",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "investorAddr",
        type: "address",
      },
    ],
    name: "cancelParticipation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "removedInvestors",
        type: "address[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "redeemed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InvestorDataWithAddress[]",
        name: "investors",
        type: "tuple[]",
      },
    ],
    name: "changeProject",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "token",
            type: "address",
          },
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "claimToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "claimDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "claimPercent",
            type: "uint256[]",
          },
        ],
        internalType: "struct RootV2.ProjectProps",
        name: "newProps",
        type: "tuple",
      },
    ],
    name: "changeProjectProps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "claimProject",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "token",
            type: "address",
          },
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "claimToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "claimDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "claimPercent",
            type: "uint256[]",
          },
        ],
        internalType: "struct RootV2.ProjectProps",
        name: "props",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "offchainId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "redeemed",
        type: "uint256[]",
      },
    ],
    name: "createProject",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20UpgradeableWithDecimals",
        name: "token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "investors",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getChainID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "getCollectedFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "getIdoBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "boxIDs",
        type: "uint256[]",
      },
    ],
    name: "getInoBalance",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
    ],
    name: "getInvestorsBalancesFromIdo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "swap",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fcfs",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.BalanceType[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "boxIDs",
        type: "uint256[]",
      },
    ],
    name: "getInvestorsBalancesFromIno",
    outputs: [
      {
        components: [
          {
            internalType: "uint256[]",
            name: "boxCounts",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InoBalanceReturnType[]",
        name: "",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256[]",
            name: "boxCounts",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InoBalanceReturnType[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "investors",
        type: "address[]",
      },
    ],
    name: "getInvestorsFromProject",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "redeemed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InvestorData[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "investorAddr",
        type: "address",
      },
    ],
    name: "getLastClaimAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "lastClaimAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastClaimIndex",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20UpgradeableWithDecimals",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "redeemed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "getRedeemedConverted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSigner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "getUserFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "users",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "getUsersFees",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "investor",
        type: "address",
      },
    ],
    name: "investorDataFromProject",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "redeemed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InvestorData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "investor",
        type: "address",
      },
    ],
    name: "investorDataWithProject",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "token",
            type: "address",
          },
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "claimToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "claimDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "claimPercent",
            type: "uint256[]",
          },
        ],
        internalType: "struct RootV2.ProjectProps",
        name: "props",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "redeemed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct RootV2.InvestorData",
        name: "investorData",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "projectById",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "token",
            type: "address",
          },
          {
            internalType: "contract IERC20UpgradeableWithDecimals",
            name: "claimToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "price",
            type: "uint256",
          },
          {
            internalType: "uint256[]",
            name: "claimDates",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "claimPercent",
            type: "uint256[]",
          },
        ],
        internalType: "struct RootV2.ProjectProps",
        name: "props",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
    ],
    name: "projectPauseToggle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "projectTokensReturnedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "projectId",
            type: "uint256",
          },
          {
            internalType: "enum VoucherV2.RedeemType",
            name: "redeemType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "investorAddr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expireTime",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct VoucherV2.RedeemIdoVoucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    name: "redeemIdo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "projectId",
            type: "uint256",
          },
          {
            internalType: "enum VoucherV2.RedeemType",
            name: "redeemType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "address",
            name: "investorAddr",
            type: "address",
          },
          {
            internalType: "uint256[]",
            name: "boxIDs",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "boxCounts",
            type: "uint256[]",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expireTime",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct VoucherV2.RedeemInoVoucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    name: "redeemIno",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "projectId",
            type: "uint256",
          },
          {
            internalType: "enum VoucherV2.RefundType",
            name: "refundType",
            type: "uint8",
          },
          {
            internalType: "enum VoucherV2.OfferingType",
            name: "offeringType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "investorAddr",
            type: "address",
          },
          {
            internalType: "address",
            name: "token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expireTime",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct VoucherV2.RefundVoucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    name: "refund",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
    ],
    name: "removeAdmins",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "projectId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addrs",
        type: "address[]",
      },
      {
        internalType: "enum VoucherV2.OfferingType",
        name: "offeringType",
        type: "uint8",
      },
    ],
    name: "removeBalances",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "projectId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "investorAddr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "expireTime",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct VoucherV2.ReturnProjectTokensVoucher",
        name: "voucher",
        type: "tuple",
      },
    ],
    name: "returnProjectTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newSigner",
        type: "address",
      },
    ],
    name: "setSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20UpgradeableWithDecimals",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RootV2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RootV2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RootV2__factory extends ContractFactory {
  constructor(...args: RootV2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(overrides?: Overrides & { from?: string }): Promise<RootV2> {
    return super.deploy(overrides || {}) as Promise<RootV2>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): RootV2 {
    return super.attach(address) as RootV2;
  }
  override connect(signer: Signer): RootV2__factory {
    return super.connect(signer) as RootV2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RootV2Interface {
    return new utils.Interface(_abi) as RootV2Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): RootV2 {
    return new Contract(address, _abi, signerOrProvider) as RootV2;
  }
}
